// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3iKrd","errorLogs":"EditorFooter_errorLogs__18eMJ"};